window.analytics = {
    logEvent: function (eventName) {
        return new Promise(resolve => {
            const originalSendBeacon = navigator.sendBeacon;
            /**
             * Set navigator.sendBeacon to undefined, because it's the only known way to prevent gtag from using it to send
             * the event. If it's used, there is no guarantee that events will be sent if we redirect to a mobile app
             * immediately after sending the event. By setting it to undefined, regular xhr will be used to send the event.
             */
            navigator.sendBeacon = undefined;

            const _resolve = () => {
                navigator.sendBeacon = originalSendBeacon;
                resolve();
            };

            let timeout = setTimeout(() => _resolve(), 1000);
            gtag('event', eventName, {
                'event_callback': () => {
                    clearTimeout(timeout);
                    _resolve();
                },
                method: 'Standard'
            });
        })
    },

    setUserId: function (userId) {
        gtag('set', { 'user_id': userId })
    },
}
